import { DateTime } from 'luxon'

import type { TimelineEvent } from "@/lib/types"

const DEFAULT_TIMEZONE = "America/New_York"

export const timelineEvents: TimelineEvent[] = [
    {
        id: "1",
        title: "Auditions Open!",
        description: "Auditions are open! If you are a new or existing content creator looking to become a Vtuber who wants to build a community around their favourite games, we want you!",
        date: DateTime.fromISO("2026-02-23T00:00:00", { zone: DEFAULT_TIMEZONE }),
        spacingAfter: 350,
    },
    {
        id: "2",
        title: "Auditions Closed",
        description: "Auditions are closed! Our team will review all applications and begin sending out results shortly.",
        date: DateTime.fromISO("2026-04-13T23:59:59", { zone: DEFAULT_TIMEZONE }),
        spacingAfter: 150,
    },
    {
        id: "3",
        title: "Auditions Results",
        description: `All applicants will be contacted regarding the results of their application by the end of this day.\n
                        Please check the email you have provided us with during your application (check spam/junk too!).\n
                        If you have not been contacted, please let us know!`,
        date: DateTime.fromISO("2026-04-16T23:59:59", { zone: DEFAULT_TIMEZONE }),
        spacingAfter: 100,
    },
    {
        id: "4",
        title: "Interviews",
        description: `We will begin interviews with our shortlisted candidates.`,
        date: DateTime.fromISO("2026-04-18T00:00:00", { zone: DEFAULT_TIMEZONE }),
        spacingAfter: 0,
    }
]
